import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { priceShape } from "shapes";

import Period from "components/Period";
import Unit from "components/Unit";
import { symbolizeCurrency, Translate } from "utils";
import { getFallbackLocale } from "utils/locale";

import styles from "./Price.css";

const { t } = new Translate();

const Price = ({ isBold, isPeriodBlack, isUnitBlack, label, price }) => {
  if (!price || !price.value) return null;
  const value = price.value.toLocaleString(getFallbackLocale(), {
    maximumFractionDigits: 2,
  });
  const unitOrFloor = price.unit === "space" || price.unit === "floor";

  return (
    <div className={styles.root}>
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.price}>
        <div className={cx({ [styles.bold]: isBold })}>
          <span className={styles.value}>{value}</span>
          <span className={styles.currency}>{symbolizeCurrency(price.currency)}</span>
        </div>
        {price.unit && (
          <>
            <div>{t("per")}</div>
            {!unitOrFloor && <Unit isBlack={isUnitBlack} unit={price.unit} />}
            {price.period && (
              <Period
                isBlack={isPeriodBlack}
                period={price.period}
                separator={unitOrFloor ? "" : "/"}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

Price.propTypes = {
  label: PropTypes.string,
  price: PropTypes.shape(priceShape),
  isBold: PropTypes.bool,
  isPeriodBlack: PropTypes.bool,
  isUnitBlack: PropTypes.bool,
};

Price.defaultProps = {
  price: {
    period: "",
    value: 0,
    currency: "",
    unit: "",
  },
  isBold: true,
  isPeriodBlack: true,
  isUnitBlack: true,
};

export default Price;
